// extracted by mini-css-extract-plugin
module.exports = {"table":"card-list_table__3SgKB","italic":"card-list_italic__2t9Od","subFulfilledDate":"card-list_subFulfilledDate__3R_7f","subBusinessId":"card-list_subBusinessId__2MG9w"};